import React from 'react';
import { Provider } from 'react-redux';

import HomeTabs from 'company-app/comps/HomeTabs';
import companyStore from 'company-app/redux/company.store';
import { companyStoreContext } from 'company-app/redux/company.store';

const Operations = () => {
    return (
        <Provider store={companyStore} context={companyStoreContext}>
            <HomeTabs parentType='admin' tabContentXPadding='2.5rem' />
        </Provider>
    );
};

export default Operations;
